import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classnames from "classnames";
import { useDropdown } from "@/hooks";
import styles from "@/styles/DropdownMenu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function DropdownMenu(_ref) {
  var _classnames2;

  var _ref$mouseOver = _ref.mouseOver,
      mouseOver = _ref$mouseOver === void 0 ? false : _ref$mouseOver,
      _ref$right = _ref.right,
      right = _ref$right === void 0 ? false : _ref$right,
      button = _ref.button,
      children = _ref.children,
      scopedClass = _ref.scopedClass;

  var _useDropdown = useDropdown({
    mouseOver: mouseOver
  }),
      buttonRef = _useDropdown.buttonRef,
      contentRef = _useDropdown.contentRef,
      show = _useDropdown.show,
      listeners = _useDropdown.listeners;

  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(styles.dropdown, " ").concat(scopedClass),
    onMouseOver: listeners.handleMouseOver,
    onMouseLeave: listeners.handleMouseLeave,
    children: [/*#__PURE__*/_jsx("div", {
      ref: buttonRef,
      className: classnames(styles.button, scopedClass, _defineProperty({}, styles.show, show)),
      onClick: listeners.handleClick,
      children: button
    }), /*#__PURE__*/_jsx("div", {
      ref: contentRef,
      className: classnames(styles.content, scopedClass, (_classnames2 = {}, _defineProperty(_classnames2, styles.show, show), _defineProperty(_classnames2, styles.right, right), _classnames2)),
      children: children
    })]
  });
}